import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { sourceService } from '../services/source/source.service';
import type {
    BulkUpdateSourceFileFieldsBody,
    DqDataProfilingBody,
    DqStatsBody,
    SourceFileRegisteredField,
    SourceFilesBody,
} from '../services/source/source.types';

export const useCreateSourceFileAndFieldsMutation = (
    options?: UseMutationOptions<
        SourceFileRegisteredField,
        Error,
        SourceFilesBody
    >
) => {
    return useMutation<
        SourceFileRegisteredField,
        Error,
        SourceFilesBody
    >({
        mutationFn: sourceService.createSourceFileAndFields,
        ...options,
    })
}

export const useKickoffDqStatsMutation = (
    options?: UseMutationOptions<void, Error, DqStatsBody>
) => {
    return useMutation<void, Error, DqStatsBody>({
        mutationFn: sourceService.kickoffDqStats,
        ...options,
    })
}

export const useTriggerDataProfilingMutation = (
    options?: UseMutationOptions<void, Error, DqDataProfilingBody>
) => {
    return useMutation<void, Error, DqDataProfilingBody>({
        mutationFn: sourceService.triggerDataProfiling,
        ...options,
    })
}

export const useBulkUpdateSourceFileFieldsMutation = (
    options?: UseMutationOptions<void, Error, BulkUpdateSourceFileFieldsBody>
) => {
    return useMutation<void, Error, BulkUpdateSourceFileFieldsBody>({
        mutationFn: sourceService.bulkUpdateSourceFileFields,
        ...options,
    })
}